"use client";

import { c as _c } from "react/compiler-runtime";
import { motion, useInView, type Variants } from "framer-motion";
import { useRef } from "react";
import Image from "next/image";
import type { HomeServiceSectionContent } from "@/features/home/types/home-page-content";
interface HomeServiceSectionProps {
  content: HomeServiceSectionContent;
}
export function HomeServiceSection(t0) {
  const $ = _c(57);
  const {
    content
  } = t0;
  const containerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      once: true,
      margin: "-100px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isInView = useInView(containerRef, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      hidden: t2,
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1
        }
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const containerVariants = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0,
      y: 20
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      hidden: t4,
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.6,
          ease: "easeOut"
        }
      }
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const itemVariants = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      hidden: t6,
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
          delayChildren: 0.4
        }
      }
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const gridVariants = t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      opacity: 0,
      scale: 0.95
    };
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      hidden: t8,
      visible: {
        opacity: 1,
        scale: 1,
        transition: {
          duration: 0.5,
          ease: "easeOut"
        }
      }
    };
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const gridItemVariants = t9;
  const t10 = isInView ? "visible" : "hidden";
  let t11;
  if ($[9] !== content.titleEmphasis) {
    t11 = <span className="text-accent italic">{content.titleEmphasis}</span>;
    $[9] = content.titleEmphasis;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== content.title || $[12] !== t11) {
    t12 = <motion.h2 variants={itemVariants} className="font-serif text-4xl text-foreground md:text-5xl lg:text-6xl">{content.title} {t11}</motion.h2>;
    $[11] = content.title;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== content.quote) {
    t13 = <p className="max-w-sm text-sm leading-relaxed font-medium text-muted-foreground md:text-base">{content.quote}</p>;
    $[14] = content.quote;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== content.authorImageAlt) {
    t14 = <div className="h-12 w-12 shrink-0 overflow-hidden rounded-full bg-gray-200"><Image src="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?q=80&w=200&h=200&auto=format&fit=crop" alt={content.authorImageAlt} width={48} height={48} className="h-full w-full object-cover grayscale" /></div>;
    $[16] = content.authorImageAlt;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== content.authorName) {
    t15 = <p className="font-semibold text-foreground">{content.authorName}</p>;
    $[18] = content.authorName;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== content.authorRole) {
    t16 = <p className="text-muted-foreground">{content.authorRole}</p>;
    $[20] = content.authorRole;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t15 || $[23] !== t16) {
    t17 = <div className="text-left text-sm">{t15}{t16}</div>;
    $[22] = t15;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t14 || $[26] !== t17) {
    t18 = <div className="flex items-center gap-4">{t14}{t17}</div>;
    $[25] = t14;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== t13 || $[29] !== t18) {
    t19 = <motion.div variants={itemVariants} className="mx-auto flex max-w-2xl flex-col items-center gap-6 md:flex-row">{t13}{t18}</motion.div>;
    $[28] = t13;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t10 || $[32] !== t12 || $[33] !== t19) {
    t20 = <motion.div variants={containerVariants} initial="hidden" animate={t10} className="flex flex-col items-center space-y-12 text-center">{t12}{t19}</motion.div>;
    $[31] = t10;
    $[32] = t12;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  const t21 = isInView ? "visible" : "hidden";
  let t22;
  if ($[35] !== content.categories) {
    let t23;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = category => <motion.div className="flex min-h-44 items-center border-r border-b border-border p-8 transition-colors duration-300 hover:bg-muted md:min-h-52 md:p-10" key={category.id} variants={gridItemVariants}><h3 className="font-serif text-3xl leading-tight tracking-tight whitespace-pre-line text-foreground md:text-4xl">{category.title}</h3></motion.div>;
      $[37] = t23;
    } else {
      t23 = $[37];
    }
    t22 = content.categories.map(t23);
    $[35] = content.categories;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[38] !== content.moreLabel) {
    t23 = <p className="mb-4 font-serif text-2xl text-accent italic">{content.moreLabel}</p>;
    $[38] = content.moreLabel;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== content.moreTitle) {
    t24 = <h3 className="font-serif text-3xl leading-tight tracking-tight whitespace-pre-line text-accent italic">{content.moreTitle}</h3>;
    $[40] = content.moreTitle;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t23 || $[43] !== t24) {
    t25 = <div>{t23}{t24}</div>;
    $[42] = t23;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== content.ctaLabel) {
    t26 = <div className="mt-12"><button className="rounded-full border border-accent px-6 py-2.5 text-sm font-semibold text-accent transition-colors duration-300 hover:bg-accent hover:text-white">{content.ctaLabel}</button></div>;
    $[45] = content.ctaLabel;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== t25 || $[48] !== t26) {
    t27 = <motion.div variants={gridItemVariants} className="flex min-h-44 flex-col justify-between border-r border-b border-border bg-muted/50 p-8 md:min-h-52 md:p-10">{t25}{t26}</motion.div>;
    $[47] = t25;
    $[48] = t26;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== t21 || $[51] !== t22 || $[52] !== t27) {
    t28 = <motion.div variants={gridVariants} initial="hidden" animate={t21} className="mt-20 grid auto-rows-fr grid-cols-1 border-t border-l border-border md:mt-28 md:grid-cols-2 lg:grid-cols-3">{t22}{t27}</motion.div>;
    $[50] = t21;
    $[51] = t22;
    $[52] = t27;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] !== t20 || $[55] !== t28) {
    t29 = <section ref={containerRef} className="z-40 bg-background px-6 py-24 text-foreground md:px-12 md:py-32"><div className="mx-auto max-w-7xl">{t20}{t28}</div></section>;
    $[54] = t20;
    $[55] = t28;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  return t29;
}